module.exports = __webpack_public_path__ + "img/cosmetology-explore.500e1b4a.jpg";